import { FC, useEffect } from "react";
import {
    useLoadingMatches,
    useProfile,
    useUserActionsCheckList,
} from "./hooks";
import { routes } from "../route/constants";
import { useHistory } from "react-router-dom";

export const useOnboardingInfo = () => {
    const userActionsCheckList = useUserActionsCheckList() || {};
    const profile = useProfile();
    const history = useHistory();
    const loading = useLoadingMatches();

    const {
        onboardingCompleted,
        matchCreatedCountPhone = 0,
        matchCreatedCountWatch = 0,
    } = userActionsCheckList;

    // Only skip if explicitly completed
    const isCompleted = onboardingCompleted === true;

    // Also skip if user has created matches (they've used the app)
    const hasSufficientActions =
        matchCreatedCountPhone > 0 || matchCreatedCountWatch > 0;

    // Don't redirect if already on an onboarding/register page
    const isOnboardingPage =
        history.location.pathname?.includes("onboarding") ||
        history.location.pathname?.includes("register");

    // Show onboarding unless completed or has matches
    const showOnboarding =
        !isCompleted && !hasSufficientActions && !isOnboardingPage;

    // Where to send them based on their state
    const pageRoute =
        onboardingCompleted === false
            ? routes.registerStepTwo // Vest users start at step 2
            : profile?.firstName && profile?.lastName
              ? routes.onboardingGettingStarted
              : routes.registerStepTwo;

    return {
        showOnboarding,
        isReady: loading === false,
        pageRoute,
    };
};

export const OnBoardingManager: FC<{}> = () => {
    const { showOnboarding, isReady, pageRoute } = useOnboardingInfo();
    const history = useHistory();

    useEffect(() => {
        if (isReady && showOnboarding) {
            history.replace(pageRoute);
        }
    }, [history, isReady, showOnboarding, pageRoute]);

    return null;
};
